import React from 'react';

import { Card, Page, Text } from '../uiold';

type Props = {
  title?: string;
};

export default function NoAccessPage(props: Props) {
  let { title } = props;

  return (
    <Page>
      <Page.Header title={title ?? ''} />
      <Card>
        <Text>
          {t(
            'You do not have access to this feature. Please contact your market manager for access.',
          )}
        </Text>
      </Card>
    </Page>
  );
}
